import styled from 'styled-components';
import media from 'src/styles/Media.styled';

export const StyledTextDiv = styled.div`
    font-family: ${(props) =>
        props.fontFamily ? props.fontFamily : 'AvenirNextWorld Demi'};
    font-size: ${(props) => (props.fontSize ? props.fontSize : '13px')};
    letter-spacing: ${(props) =>
        props.letterSpacing ? props.letterSpacing : '0px'};
    color: ${(props) => (props.color ? props.color : '#3c3c3c')};
    opacity: ${(props) => (props.opacity ? props.opacity : 1)};
    padding: ${(props) => props.padding};
    text-align: ${(props) => props.textAlign};
    margin-left: ${(props) => props.marginLeft};
    margin-top: ${(props) => props.marginTop};
    margin-right: ${(props) => props.marginRight};
    text-decoration: ${(props) => props.textDecoration};
    font-weight: ${(props) => (props.fontWeight ? props.fontWeight : 'normal')};
    width: ${(props) => props.width};
    min-width: ${(props) => props.minWidth};
`;

export const NoDataText = styled.div`
    /* font: italic normal normal 14px/20px Avenir Next World; */
    font-family: 'AvenirNextWorld Italic';
    font-weight: normal;
    letter-spacing: 0px;
    font-size: ${(props) => (props.fontSize ? props.fontSize : '14px')};
    color: ${(props) => (props.color ? props.color : '#040404')};
    opacity: 0.7;
    padding: ${(props) => props.padding};
`;

export const TitleComponent = styled.p`
    font-family: AvenirNextWorld Demi;
    font-size: 20px;
    align-content: left;
    color: #140f4b;
    line-height: ${(props) => (props.lineHeight ? props.lineHeight : '20px')};
    padding-top: ${(props) => (props.paddingTop ? props.paddingTop : '23px')};
    padding-bottom: ${(props) =>
        props.paddingBottom ? props.paddingBottom : '12px'};
    ${media.smalDevice`
        padding-top:15px;
        padding-bottom:20px;
    `};
    ${media.mobileDevice`
        padding-top:0px;
        padding-bottom:0px;
        font-size: 24px;
        line-height: 42px;
    `};
`;
